import axios from 'axios';

function resolveBaseURL(isServer) {
  if (isServer) {
    return process.env.API_URL || 'http://reverse-proxy:3003';
  }
  return process.env.NEXT_PUBLIC_SITE_ORIGIN || 'http://localhost:3003';
}

export function createApi(req) {
  const isServer = typeof window === 'undefined';

  const headers = {
    'Content-Type': 'application/json',
  };

  // Forward the incoming request's cookies during SSR
  if (isServer && req?.headers?.cookie) {
    headers.cookie = req.headers.cookie;
  }

  return axios.create({
    baseURL: resolveBaseURL(isServer),
    withCredentials: true,
    timeout: 20000,
    headers,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
  });
}

// Default instance for client-side usage
const api = createApi();

export default api;
